<template>
  <div>
    <div class="field-container">
      <div class="field-label">
        <div class="text">Teacher</div>
        <i class="el-icon-user-solid" />
      </div>
      <div class="field-content">
        <div :style="`background-image: url(${teacher.avatar});`" class="avatar-img" />
        <span class="name-text">{{ teacher.full_name }}</span>
      </div>
    </div>
    <div class="field-container">
      <div class="field-label">
        <div class="text">Assistant</div>
        <i v-if="$store.state.userPower === 'A'" class="el-icon-plus add-action-icon"/>
        <i class="el-icon-user-solid" />
      </div>
      <div class="field-content" v-if="assistant">
        <div :style="`background-image: url(${assistant.avatar});`" class="avatar-img" />
        <span class="name-text">{{ assistant.full_name }}</span>
      </div>
      <div class="field-no-data" v-else>No assistant in this class.</div>
    </div>
    <div class="field-container">
      <div class="field-label">
        <div class="text">Students</div>
        <i v-if="$store.state.userPower === 'A'" class="el-icon-plus add-action-icon"/>
        <i class="el-icon-user-solid" />
      </div>
      <div v-if="students.length">
        <div class="field-content" v-for="student in students" :key="student.id">
          <div :style="`background-image: url(${student.avatar});`" class="avatar-img" />
          <span class="name-text">{{ student.full_name }}</span>
        </div>
      </div>
      <div class="field-no-data" v-else>No student in this class.</div>
    </div>
  </div>
</template>

<script>
import { getMembersByClass } from "@/api";

export default {
  name: "Members",
  data() {
    return {
      teacher: {},
      assistant: {},
      students: []
    };
  },
  mounted() {
    this.getMembers();
  },
  methods: {
    getMembers() {
      getMembersByClass(this.$route.params.class_id).then(res => {
        this.teacher = res.teacher;
        this.assistant = res.assistant;
        this.students = res.students;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.field-container {
  margin: 16px 80px;
  padding-bottom: 32px;
  .field-label {
    color: #1e88e5;
    font-size: 32px;
    display: flex;
    padding: 8px;
    border-bottom: 1px solid #1e88e5;
    .text {
      flex-grow: 1;
    }
    .add-action-icon {
      cursor: pointer;
      margin-right: 32px;
      &:hover {
        text-shadow: .1rem 0rem .25rem #90caf9,-.1rem 0rem .25rem #90caf9,0rem .1rem .25rem #90caf9,0rem -.1rem .25rem #90caf9;
      }
    }
  }
  .field-content {
    padding: 16px 8px;
    display: flex;
    .avatar-img {
      width: 32px;
      height: 32px;
      background-position: center 10%;
      background-size: cover;
      border: 1px rgba(0, 0, 0, 0.25) solid;
      border-radius: 50%;
      overflow: hidden;
    }
    .name-text {
      font-size: 20px;
      font-weight: bold;
      flex-grow: 1;
      height: 32px;
      line-height: 32px;
      margin-left: 48px;
    }
  }
  .field-no-data {
    text-align: center;
    padding: 16px 8px;
    font-size: 24px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.35);
  }
}
</style>